module.exports = __webpack_public_path__ + "fonts/fa-regular-400.5dd3976c.woff";